module.exports = "/fonts/Lato-Bold.ttf";